import React, { useState, useEffect } from 'react';
import { authFetch } from '../utils/api';

export default function MonthlyBudgetCell({ person_id, catId, year, currentMonthly, onUpdate }) {
    const [isEditing, setIsEditing] = useState(false);
    
    // 💡 Synchronisation avec les calculs du parent (Source 17)
    const [tempValue, setTempValue] = useState(currentMonthly.toFixed(2));

    useEffect(() => {
        setTempValue(currentMonthly.toFixed(2));
    }, [currentMonthly]);

    const handleSave = async () => {
        try {
            // 💡 Règle métier : On définit un total annuel cible basé sur ce mensuel (Source 13, 17)
            const targetAnnual = parseFloat(tempValue) * 12;
            
            await authFetch.post('/budgets/annual', {
                person_id: person_id,
                categorie_id: catId,
                year: year,
                total_annual: targetAnnual
            });
            setIsEditing(false);
            onUpdate(); 
        } catch (err) {
            console.error("Erreur lors de la mise à jour mensuelle:", err);
        }
    };

    return (
        <td 
            onClick={() => { if(!isEditing) setIsEditing(true); }}
            style={{
                padding: '8px',
                border: '1px solid #ccc',
                textAlign: 'right',
                backgroundColor: isEditing ? '#fff' : '#e1f5fe',
                cursor: 'pointer',
                fontWeight: 'bold',
                minWidth: '90px'
            }}
        >
            {isEditing ? (
                <input 
                    autoFocus
                    type="number"
                    step="0.01"
                    value={tempValue}
                    onChange={(e) => setTempValue(e.target.value)}
                    onBlur={handleSave}
                    onKeyDown={(e) => e.key === 'Enter' && handleSave()}
                    style={{ width: '100%', textAlign: 'right', border: 'none', outline: 'none', fontWeight: 'bold' }}
                />
            ) : (
                <span>{currentMonthly.toFixed(2)} €</span>
            )}
        </td>
    );
}